import React, {useContext, useEffect, useState} from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { Button } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import Footer from '../footer';
import SocketClient from '../../helpers/connection';
import axios, { AxiosResponse } from "axios";
import Swal from "sweetalert2";
import EventContext from "../../contexts/event";
import UserContext from "../../contexts/user";
import { useHistory } from "react-router-dom";

const QuizLogin: React.FC = () => {
  const intl = useIntl();
  const userContext = useContext(UserContext);
  const eventContext = useContext(EventContext);
  const history = useHistory();
  const { setUser, setListUser } = userContext;
  const [submited, setSubmited] = useState(false);


  // emit login action to moderator via socket message using an api
  function loginBroadcast(jsonData:any) {
    console.log('loginBroadcast',jsonData)
    const headers = {
      'Content-Type': 'application/json',
    }

    axios.post(`${process.env.REACT_APP_SOCKET_URL}/quiz-user-login`, jsonData, {
      headers: headers
    })
        .then((response) => {
          console.log('loginBroadcast s',response)
        })
        .catch((error) => {
          console.log('loginBroadcast e',error)
        })
  }


  return (
    <div className="login-landing">
      <div className="login-container">
        <div className="login">
          <Formik
            initialValues={{
              code: "",
              nickname: "",
            }}
            onSubmit={async values => {
              /*handle login functions*/
              if(!submited){
                setSubmited(true);
                axios({
                  method: "POST",
                  //url: 'http://localhost:4000/stage/api/quiz/login',
                  url: `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/login`,
                  data: {
                    code: values.code,
                    name: values.nickname
                  },
                }).then((res) => {
                  console.log(res);

                  try {
                    if (res.data.statusCode === 201) {

                      loginBroadcast({name:values.nickname,code:values.code,presentationId:res.data.presentationId,createdAt:Date.now()});

                      Swal.fire({
                        title: "Success!",
                        text: "You are successfully logged in",
                        icon: "success",
                      }).then( async () => {
                        //await SocketClient.initSocket(res.data.presentationId)
                        const { token, id, user } = res.data;
                        setListUser(JSON.stringify({ token, id, user }));
                        setUser(user);


                        localStorage.setItem(
                            `token-${
                                document.location.pathname.split("/")[1] || "invalid"
                            }`,
                            token
                        );
                        // SocketClient.sendMessage(`{"action":"sendMessage","message":"${res.data.presentationId}:quizLogin@${values.nickname}"}`);

                        if(res.data.quizStatus){
                          history.push(
                              `/${eventContext.slug}/${res.data.presentationId}/questions`
                          )
                        }else {
                          history.push(
                              `/${eventContext.slug}/${res.data.presentationId}/quiz-intro`
                          )
                        }

                      });


                    } else {
                      setSubmited(false);
                      Swal.fire({
                        title: "Error!",
                        text: 'Invalid Invite Code',
                        icon: "error",

                      })
                    }
                  } catch (e) {

                  }
                  console.log("QUIZ LOGIN", res);

                });
              }





               console.log(values);
            }}
          >
            {({ isSubmitting }) => {
              return (
                <Form className="m-t-30">
                  <h4><FormattedMessage id="please.login" /></h4>
                  <div className="form-group m-t-40">
                    <Field required placeholder={intl.formatMessage({ id: 'event.code' })} className="form-control" type="text" name="code" />
                    <ErrorMessage className="invalid-feedback" name="code" component="div" />
                  </div>
                  <div className="form-group">
                    <Field required placeholder={intl.formatMessage({ id: 'quiz.your.nickname' })} className="form-control" type="nickname" name="nickname" />
                    <ErrorMessage className="invalid-feedback" name="nickname" component="div" />
                  </div>
                  <div className="login-button-container event-login-btn-cont justify-content-center m-t-30">
                    <div>
                      <Button color="primary" type="submit" disabled={isSubmitting}>
                        <FormattedMessage id="common.enter.button" />
                      </Button>
                    </div>
                  </div>
                  {/* <div className="common-styles m-t-20"><Button onClick={() => setFormType('forgotPassword')} type="button" color="link">{intl.formatMessage({ id: 'forgot.password' })}</Button></div>
            <div className="common-styles m-t-10 m-b-10">{intl.formatMessage({ id: 'no.account' })} <Button onClick={() => setFormType('signup')} color="link" type="button">{intl.formatMessage({ id: 'create.account' })}</Button></div> */}
                </Form>
              )
            }}
          </Formik>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default QuizLogin;
